export const useContactUs = () => {
  
  type Inputs = {
    name?: string;
    email?: string;
    message?: string;
    phone?: string;
  };
  const {$api} = useNuxtApp();
  const {toast} = useToast();

  const loading = ref(false);

  const onContactUs = async (inputs: Inputs) => {
    try {
      loading.value = true;
      await $api.post("/contact-us", inputs);
      toast({type: "success", content: "تم الارسال بنجاح"});
    } catch (err) {
      console.log(err);
    } finally {
      loading.value = false;
    }
  };

  return {onContactUs, loading};
};
